/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorHospitalAttribute from './doctor-hospital-attribute';
import DoctorHospitalAttributeDetail from './doctor-hospital-attribute-detail';
import DoctorHospitalAttributeUpdate from './doctor-hospital-attribute-update';
import DoctorHospitalAttributeDeleteDialog from './doctor-hospital-attribute-delete-dialog';

const DoctorHospitalAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorHospitalAttribute />} />
    <Route path="new" element={<DoctorHospitalAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorHospitalAttributeDetail />} />
      <Route path="edit" element={<DoctorHospitalAttributeUpdate />} />
      <Route path="delete" element={<DoctorHospitalAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorHospitalAttributeRoutes;
